export type BubbleMenuSide = "top" | "bottom";

type RectLike = Pick<DOMRectReadOnly, "top" | "height">;

export function inferBubbleMenuSide(menuRect: RectLike, selectionRect: RectLike): BubbleMenuSide {
  const menuCenterY = menuRect.top + menuRect.height / 2;
  const selectionCenterY = selectionRect.top + selectionRect.height / 2;

  return menuCenterY > selectionCenterY ? "bottom" : "top";
}
